// utils/countryCodes.js
const countryCodes = [
  { code: "93", label: "🇦🇫 Afghanistan" },
  { code: "355", label: "🇦🇱 Albania" },
  { code: "213", label: "🇩🇿 Algeria" },
  { code: "376", label: "🇦🇩 Andorra" },
  { code: "244", label: "🇦🇴 Angola" },
  { code: "54", label: "🇦🇷 Argentina" },
  { code: "374", label: "🇦🇲 Armenia" },
  { code: "61", label: "🇦🇺 Australia" },
  { code: "43", label: "🇦🇹 Austria" },
  { code: "994", label: "🇦🇿 Azerbaijan" },
  { code: "973", label: "🇧🇭 Bahrain" },
  { code: "880", label: "🇧🇩 Bangladesh" },
  { code: "375", label: "🇧🇾 Belarus" },
  { code: "32", label: "🇧🇪 Belgium" },
  { code: "501", label: "🇧🇿 Belize" },
  { code: "229", label: "🇧🇯 Benin" },
  { code: "975", label: "🇧🇹 Bhutan" },
  { code: "591", label: "🇧🇴 Bolivia" },
  { code: "387", label: "🇧🇦 Bosnia and Herzegovina" },
  { code: "267", label: "🇧🇼 Botswana" },
  { code: "55", label: "🇧🇷 Brazil" },
  { code: "359", label: "🇧🇬 Bulgaria" },
  { code: "226", label: "🇧🇫 Burkina Faso" },
  { code: "257", label: "🇧🇮 Burundi" },
  { code: "855", label: "🇰🇭 Cambodia" },
  { code: "237", label: "🇨🇲 Cameroon" },
  { code: "1", label: "🇨🇦 Canada" },
  { code: "238", label: "🇨🇻 Cape Verde" },
  { code: "236", label: "🇨🇫 Central African Republic" },
  { code: "235", label: "🇹🇩 Chad" },
  { code: "56", label: "🇨🇱 Chile" },
  { code: "86", label: "🇨🇳 China" },
  { code: "57", label: "🇨🇴 Colombia" },
  { code: "269", label: "🇰🇲 Comoros" },
  { code: "242", label: "🇨🇬 Congo" },
  { code: "243", label: "🇨🇩 Congo (DRC)" },
  { code: "506", label: "🇨🇷 Costa Rica" },
  { code: "385", label: "🇭🇷 Croatia" },
  { code: "53", label: "🇨🇺 Cuba" },
  { code: "357", label: "🇨🇾 Cyprus" },
  { code: "420", label: "🇨🇿 Czech Republic" },
  { code: "45", label: "🇩🇰 Denmark" },
  { code: "253", label: "🇩🇯 Djibouti" },
  { code: "1-767", label: "🇩🇲 Dominica" },
  { code: "1-809", label: "🇩🇴 Dominican Republic" },
  { code: "593", label: "🇪🇨 Ecuador" },
  { code: "20", label: "🇪🇬 Egypt" },
  { code: "503", label: "🇸🇻 El Salvador" },
  { code: "240", label: "🇬🇶 Equatorial Guinea" },
  { code: "291", label: "🇪🇷 Eritrea" },
  { code: "372", label: "🇪🇪 Estonia" },
  { code: "251", label: "🇪🇹 Ethiopia" },
  { code: "679", label: "🇫🇯 Fiji" },
  { code: "358", label: "🇫🇮 Finland" },
  { code: "33", label: "🇫🇷 France" },
  { code: "995", label: "🇬🇪 Georgia" },
  { code: "49", label: "🇩🇪 Germany" },
  { code: "233", label: "🇬🇭 Ghana" },
  { code: "30", label: "🇬🇷 Greece" },
  { code: "502", label: "🇬🇹 Guatemala" },
  { code: "224", label: "🇬🇳 Guinea" },
  { code: "245", label: "🇬🇼 Guinea-Bissau" },
  { code: "592", label: "🇬🇾 Guyana" },
  { code: "509", label: "🇭🇹 Haiti" },
  { code: "504", label: "🇭🇳 Honduras" },
  { code: "36", label: "🇭🇺 Hungary" },
  { code: "91", label: "🇮🇳 India" },
  { code: "62", label: "🇮🇩 Indonesia" },
  { code: "98", label: "🇮🇷 Iran" },
  { code: "964", label: "🇮🇶 Iraq" },
  { code: "353", label: "🇮🇪 Ireland" },
  { code: "972", label: "🇮🇱 Israel" },
  { code: "39", label: "🇮🇹 Italy" },
  { code: "1-876", label: "🇯🇲 Jamaica" },
  { code: "81", label: "🇯🇵 Japan" },
  { code: "962", label: "🇯🇴 Jordan" },
  { code: "7", label: "🇰🇿 Kazakhstan" },
  { code: "254", label: "🇰🇪 Kenya" },
  { code: "965", label: "🇰🇼 Kuwait" },
  { code: "996", label: "🇰🇬 Kyrgyzstan" },
  { code: "856", label: "🇱🇦 Laos" },
  { code: "371", label: "🇱🇻 Latvia" },
  { code: "961", label: "🇱🇧 Lebanon" },
  { code: "266", label: "🇱🇸 Lesotho" },
  { code: "231", label: "🇱🇷 Liberia" },
  { code: "218", label: "🇱🇾 Libya" },
  { code: "423", label: "🇱🇮 Liechtenstein" },
  { code: "370", label: "🇱🇹 Lithuania" },
  { code: "352", label: "🇱🇺 Luxembourg" },
  { code: "261", label: "🇲🇬 Madagascar" },
  { code: "265", label: "🇲🇼 Malawi" },
  { code: "60", label: "🇲🇾 Malaysia" },
  { code: "960", label: "🇲🇻 Maldives" },
  { code: "223", label: "🇲🇱 Mali" },
  { code: "356", label: "🇲🇹 Malta" },
  { code: "222", label: "🇲🇷 Mauritania" },
  { code: "230", label: "🇲🇺 Mauritius" },
  { code: "52", label: "🇲🇽 Mexico" },
  { code: "373", label: "🇲🇩 Moldova" },
  { code: "377", label: "🇲🇨 Monaco" },
  { code: "976", label: "🇲🇳 Mongolia" },
  { code: "382", label: "🇲🇪 Montenegro" },
  { code: "212", label: "🇲🇦 Morocco" },
  { code: "258", label: "🇲🇿 Mozambique" },
  { code: "95", label: "🇲🇲 Myanmar" },
  { code: "264", label: "🇳🇦 Namibia" },
  { code: "977", label: "🇳🇵 Nepal" },
  { code: "31", label: "🇳🇱 Netherlands" },
  { code: "64", label: "🇳🇿 New Zealand" },
  { code: "505", label: "🇳🇮 Nicaragua" },
  { code: "227", label: "🇳🇪 Niger" },
  { code: "234", label: "🇳🇬 Nigeria" },
  { code: "47", label: "🇳🇴 Norway" },
  { code: "92", label: "🇵🇰 Pakistan" },
  { code: "970", label: "🇵🇸 Palestine" },
  { code: "507", label: "🇵🇦 Panama" },
  { code: "675", label: "🇵🇬 Papua New Guinea" },
  { code: "595", label: "🇵🇾 Paraguay" },
  { code: "51", label: "🇵🇪 Peru" },
  { code: "63", label: "🇵🇭 Philippines" },
  { code: "48", label: "🇵🇱 Poland" },
  { code: "351", label: "🇵🇹 Portugal" },
  { code: "974", label: "🇶🇦 Qatar" },
  { code: "40", label: "🇷🇴 Romania" },
  { code: "7", label: "🇷🇺 Russia" },
  { code: "250", label: "🇷🇼 Rwanda" },
  { code: "966", label: "🇸🇦 Saudi Arabia" },
  { code: "221", label: "🇸🇳 Senegal" },
  { code: "381", label: "🇷🇸 Serbia" },
  { code: "248", label: "🇸🇨 Seychelles" },
  { code: "232", label: "🇸🇱 Sierra Leone" },
  { code: "65", label: "🇸🇬 Singapore" },
  { code: "421", label: "🇸🇰 Slovakia" },
  { code: "386", label: "🇸🇮 Slovenia" },
  { code: "27", label: "🇿🇦 South Africa" },
  { code: "82", label: "🇰🇷 South Korea" },
  { code: "34", label: "🇪🇸 Spain" },
  { code: "94", label: "🇱🇰 Sri Lanka" },
  { code: "249", label: "🇸🇩 Sudan" },
  { code: "597", label: "🇸🇷 Suriname" },
  { code: "268", label: "🇸🇿 Eswatini" },
  { code: "46", label: "🇸🇪 Sweden" },
  { code: "41", label: "🇨🇭 Switzerland" },
  { code: "963", label: "🇸🇾 Syria" },
  { code: "886", label: "🇹🇼 Taiwan" },
  { code: "992", label: "🇹🇯 Tajikistan" },
  { code: "255", label: "🇹🇿 Tanzania" },
  { code: "66", label: "🇹🇭 Thailand" },
  { code: "228", label: "🇹🇬 Togo" },
  { code: "216", label: "🇹🇳 Tunisia" },
  { code: "90", label: "🇹🇷 Turkey" },
  { code: "993", label: "🇹🇲 Turkmenistan" },
  { code: "256", label: "🇺🇬 Uganda" },
  { code: "380", label: "🇺🇦 Ukraine" },
  { code: "971", label: "🇦🇪 UAE" },
  { code: "44", label: "🇬🇧 UK" },
  { code: "1", label: "🇺🇸 USA" },
  { code: "598", label: "🇺🇾 Uruguay" },
  { code: "998", label: "🇺🇿 Uzbekistan" },
  { code: "58", label: "🇻🇪 Venezuela" },
  { code: "84", label: "🇻🇳 Vietnam" },
  { code: "260", label: "🇿🇲 Zambia" },
  { code: "263", label: "🇿🇼 Zimbabwe" },
  { code: "354", label: "🇮🇸 Iceland" },
  { code: "350", label: "🇬🇮 Gibraltar" },
  { code: "378", label: "🇸🇲 San Marino" },
  { code: "389", label: "🇲🇰 North Macedonia" },
  { code: "383", label: "🇽🇰 Kosovo" },
  { code: "298", label: "🇫🇴 Faroe Islands" },
  { code: "299", label: "🇬🇱 Greenland" },
  { code: "968", label: "🇴🇲 Oman" },
  { code: "967", label: "🇾🇪 Yemen" },
  { code: "673", label: "🇧🇳 Brunei" },
  { code: "852", label: "🇭🇰 Hong Kong" },
  { code: "853", label: "🇲🇴 Macao" },
  { code: "850", label: "🇰🇵 North Korea" },
  { code: "670", label: "🇹🇱 Timor-Leste" },


  { code: "225", label: "🇨🇮 Côte d’Ivoire" },
  { code: "241", label: "🇬🇦 Gabon" },
  { code: "220", label: "🇬🇲 Gambia" },
  { code: "239", label: "🇸🇹 São Tomé and Príncipe" },
  { code: "252", label: "🇸🇴 Somalia" },
  { code: "211", label: "🇸🇸 South Sudan" },



  { code: "1-242", label: "🇧🇸 Bahamas" },
  { code: "1-246", label: "🇧🇧 Barbados" },
  { code: "1-441", label: "🇧🇲 Bermuda" },
  { code: "1-284", label: "🇻🇬 British Virgin Islands" },
  { code: "1-345", label: "🇰🇾 Cayman Islands" },
  { code: "1-473", label: "🇬🇩 Grenada" },
  { code: "1-664", label: "🇲🇸 Montserrat" },
  { code: "1-787", label: "🇵🇷 Puerto Rico" },
  { code: "1-939", label: "🇵🇷 Puerto Rico (alt)" },
  { code: "1-869", label: "🇰🇳 Saint Kitts and Nevis" },
  { code: "1-758", label: "🇱🇨 Saint Lucia" },
  { code: "1-784", label: "🇻🇨 Saint Vincent and the Grenadines" },
  { code: "1-868", label: "🇹🇹 Trinidad and Tobago" },
  { code: "1-649", label: "🇹🇨 Turks and Caicos Islands" },
  { code: "1-264", label: "🇦🇮 Anguilla" },
  { code: "1-721", label: "🇸🇽 Sint Maarten" },

 
  { code: "297", label: "🇦🇼 Aruba" },
  { code: "599", label: "🇨🇼 Curaçao / Caribbean Netherlands" },
  { code: "590", label: "🇬🇵 Guadeloupe / Saint Barthélemy / Saint Martin (FR)" },
  { code: "596", label: "🇲🇶 Martinique" },
  { code: "594", label: "🇬🇫 French Guiana" },
  { code: "508", label: "🇵🇲 Saint Pierre and Miquelon" },
  { code: "500", label: "🇫🇰 Falkland Islands" },

  { code: "686", label: "🇰🇮 Kiribati" },
  { code: "692", label: "🇲🇭 Marshall Islands" },
  { code: "691", label: "🇫🇲 Micronesia" },
  { code: "674", label: "🇳🇷 Nauru" },
  { code: "680", label: "🇵🇼 Palau" },
  { code: "685", label: "🇼🇸 Samoa" },
  { code: "677", label: "🇸🇧 Solomon Islands" },
  { code: "676", label: "🇹🇴 Tonga" },
  { code: "688", label: "🇹🇻 Tuvalu" },
  { code: "678", label: "🇻🇺 Vanuatu" }
];

export default countryCodes;
